module.exports = {"420702100":"太和镇","420702101":"东沟镇","420702102":"梁子生态管理区（镇）","420702103":"涂家垴镇","420702104":"沼山镇","420702400":"梧桐湖新区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420702.json
// module id = 1747
// module chunks = 0